import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expertdecl',
  templateUrl: './expertdecl.component.html',
  styleUrls: ['./expertdecl.component.scss']
})
export class ExpertdeclComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
